import { Navbar, Nav, Container } from 'react-bootstrap'

export default function NavBar() {
    return (
      <Container id="navigation">
           <Navbar variant="dark" expand="lg">
            <Navbar.Brand id="navigation-brand" href="#home">
              @martikitikitee
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="justify-content-end" >
                <Nav.Link href="#about">About</Nav.Link>
                <Nav.Link href="#skills">Skills</Nav.Link>
                <Nav.Link href="#projects">Projects</Nav.Link>
                <Nav.Link href="#gallery">Gallery</Nav.Link>
                <Nav.Link href="#awards">Awards</Nav.Link>
                <Nav.Link href="#appearances">Appearances</Nav.Link>
                <Nav.Link href="#cv">Curriculum Vitae</Nav.Link>
              </Nav>
            </Navbar.Collapse>  
             </Navbar>
      </Container>
    );
  }
  

  